module.exports = __webpack_public_path__ + "media/images/logo-d59bd23d.png";